import React from 'react';
import RedemptionWrapper from '../RedemptionWrapper';

const RedemptionReportPage = function RedemptionReportPage({ userRoles }) {
  return <RedemptionWrapper userRoles={userRoles} />;
};

export default RedemptionReportPage;
